/**
 * Tabs
 */
// Note: These values are used for translation keys
export const BoothTab = {
  ALL: 'all',
  BOOKMARKS: 'bookmarks',
  WORLD1: 'world',
} as const;

export type BoothTab = (typeof BoothTab)[keyof typeof BoothTab];

export const BoothTabIdIncrease: Record<BoothTab, number> = {
  [BoothTab.ALL]: -Infinity,
  [BoothTab.BOOKMARKS]: -Infinity,
  [BoothTab.WORLD1]: 0,
};

export const BoothTabTheme = {
  [BoothTab.ALL]: '#ddd',
  [BoothTab.BOOKMARKS]: '#ddd',
  [BoothTab.WORLD1]: '#F7BF12',
};

/**
 * Tab sections
 */
// Note: These values are used for translation keys
export const BoothTabSection = {
  ALL: 'all',
  AVATAR_BASES: 'avatar_bases',
  AVATAR_ASSETS: 'avatar_assets',
  AVATAR_SERVICES: 'avatar_services',
  ILLUSTRATION_2D: '2d_illustration',
  OTHER: 'other',
  CREATIVE: 'creative',
} as const;
export type BoothTabSection = (typeof BoothTabSection)[keyof typeof BoothTabSection];

export const BoothTabSectionIdIncrease: Record<BoothTabSection, number> = {
  [BoothTabSection.ALL]: -Infinity,
  [BoothTabSection.AVATAR_BASES]: 1000,
  [BoothTabSection.AVATAR_ASSETS]: 2000,
  [BoothTabSection.AVATAR_SERVICES]: 3000,
  [BoothTabSection.ILLUSTRATION_2D]: 4000,
  [BoothTabSection.OTHER]: 5000,
  [BoothTabSection.CREATIVE]: 9000,
};
